import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  deleteSchoolAwayDetail(context, payload) {
    ApiService.setHeader();
    return ApiService.delete("school/away/management", {
      params: {
        id: payload,
      },
    }).then((response) => response);
  },
};

export default {
  actions,
};
